import { initializeApp } from 'firebase/app';
import { inMemoryPersistence, browserLocalPersistence, initializeAuth, indexedDBLocalPersistence } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';
import { Capacitor } from '@capacitor/core';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyDxDnBZ-lUYDhPIz-o3xJN-nE0ycZQbAqY",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "wonderstood.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "wonderstood",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "wonderstood.firebasestorage.app",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "470513695165",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:470513695165:web:eacbe2030c5230d95ebad4",
};

const app = initializeApp(firebaseConfig);

// On iOS native app, use in-memory persistence to avoid IndexedDB hang
// We implement custom persistence using Capacitor Preferences
// On web/Android, use standard local persistence
const isNativeiOS = Capacitor.getPlatform() === 'ios' && Capacitor.isNativePlatform();

export const auth = isNativeiOS
  ? initializeAuth(app, {
      persistence: [inMemoryPersistence],
    })
  : initializeAuth(app, {
      persistence: [indexedDBLocalPersistence, browserLocalPersistence],
    });

export const db = getFirestore(app);
export const functions = getFunctions(app, 'us-central1');
export const storage = getStorage(app);

// Connect to emulators in development
// if (import.meta.env.DEV) {
//   try {
//     connectAuthEmulator(auth, 'http://localhost:9199');
//     connectFirestoreEmulator(db, 'localhost', 8081);
//     connectFunctionsEmulator(functions, 'localhost', 5002);
//   } catch (error) {
//     // Emulators already connected or not available
//   }
// }

export default app;